export const TOAST_TIMEOUT = 4000;

export const TOAST_CLASSES = {
    notice: "toast",
    danger: "toast danger",
};